// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sideBarCallout[data-v-b3576148] {\n  width: 600px;\n}\n.sidebarCallout__table th[data-v-b3576148] {\n  min-width: 152px;\n  font-weight: 300;\n}\n.sidebarCallout__table td[data-v-b3576148] {\n  padding-right: 0.5rem;\n  font-weight: 600;\n}\n.sidebarCallout__table td[data-v-b3576148]:last-child {\n  padding-right: 0px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
